import React from "react"
import PageIntro from '../../UI/PageIntro/PageIntro'

const paragraphs = [
    <>Grab a tool from the menu above. Small, single-purpose things I built because
        I needed them and got tired of hunting for a decent free version online.</>,
]

export default function Utilities() {
    return (
        <PageIntro title="Utilities" paragraphs={paragraphs}/>
    )
}
